import { render, staticRenderFns } from "./QuizAndGameLayout.vue?vue&type=template&id=f8f7b73e&scoped=true&"
import script from "./QuizAndGameLayout.vue?vue&type=script&lang=js&"
export * from "./QuizAndGameLayout.vue?vue&type=script&lang=js&"
import style0 from "./QuizAndGameLayout.vue?vue&type=style&index=0&id=f8f7b73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f7b73e",
  null
  
)

export default component.exports